import { useSession } from '@/components/session-provider';
import { useTenant } from '@/components/tenant-provider';

export function useTenantOwnerAccess() {
  const { isAdmin, isProfileLoading } = useSession();
  const { activeTenant, isTenantLoading, isTenantOwner } = useTenant();

  return {
    activeTenant,
    isAllowed: isAdmin || isTenantOwner,
    isLoading: isProfileLoading || isTenantLoading,
  };
}
